module.exports = __webpack_public_path__ + "img/xiaolachuxing.3325997f.png";